/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";

// api url
import { apiUrl_forBrands } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get brands
export let cancelGetBrandsApi;
export async function getBrands(headers, query = "") {
    if (headers) {
        const brands = await axios.get(apiUrl_forBrands + "brands?" + query, {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetBrandsApi = c;
            }),
        });
        return brands;
    } else {
        console.log("Please add required parameters");
    }
}

// add brand
export let cancelAddBrandApi;
export async function addBrand(headers, brandData) {
    if ((headers && brandData)) {
        const emails = await axios.post(
            apiUrl_forBrands + "brand",
            {
                manufacturer_name: brandData.brand_name,
            },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddBrandApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// get brand details
export let cancelGetBrandDetailsApi;
export async function getBrandDetails(headers, brandId) {
    if (headers && brandId) {
        const brands = await axios.get(apiUrl_forBrands + "brand/" + brandId, {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetBrandDetailsApi = c;
            }),
        });
        return brands;
    } else {
        console.log("Please add required parameters");
    }
}

// add brand
export let cancelEditBrandApi;
export async function editBrand(headers, brandData) {
    if ((headers && brandData)) {
        const emails = await axios.put(
            apiUrl_forBrands + "brand/" + brandData.brand_id,
            {
                manufacturer_name: brandData.brand_name,
            },
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditBrandApi = c;
                }),
            }
        );
        return emails;
    } else {
        console.log("Please add required parameters");
    }
}

// delte brand
export let cancelDeleteBrandApi;
export async function deleteBrand(headers, brandId) {
    if (headers && brandId) {
        const brands = await axios.delete(
            apiUrl_forBrands + "brand/" + brandId,
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteBrandApi = c;
                }),
            }
        );
        return brands;
    } else {
        console.log("Please add required parameters");
    }
}
